import { Card } from '../components/ui/card';
import { Link } from 'react-router';
import { StockHeroStrip, WarmMarketingBackdrop } from '../components/marketing/MarketingVisuals';

const FAQS = [
  {
    q: 'What is Two-Person Tension Delta?',
    a: "It compares your latest tension signal with your partner's and shows the size of the gap. Bigger gaps usually mean a conversation is needed before assumptions grow.",
  },
  {
    q: 'Is this private?',
    a: 'Yes. You and your partner must explicitly consent before pairing. The suite is designed around trend visibility, not exposing private journal content.',
  },
  {
    q: 'What does Rupture-to-Repair Replay do?',
    a: 'It detects times when tension spiked and later recovered, then highlights likely actions that helped. It is your personal “what worked before” timeline.',
  },
  {
    q: 'How is Conversation Micro-Coach different from normal AI chat?',
    a: 'Micro-Coach focuses specifically on message drafts: escalation risk, clearer phrasing, and safer rewrites before you send.',
  },
  {
    q: 'What is Attachment Drift Detection?',
    a: 'It watches short-term shifts from your normal baseline and flags when your behavior is trending more anxious or avoidant than usual.',
  },
  {
    q: 'What is the Silent Signal Layer?',
    a: 'It tracks subtle behavior metrics (like response delay, cancellation patterns, initiation ratio) to surface early warning signs without reading message content.',
  },
  {
    q: 'What is Repair Challenge Mode?',
    a: 'A 7-day co-op sequence with small daily actions that help rebuild safety, clarity, and consistency after tension spikes.',
  },
  {
    q: 'What is Therapist Bridge Export?',
    a: 'A compact summary you can share in therapy: top triggers, what helped most, and near-term risk windows.',
  },
  {
    q: 'What is Future-Self Nudge?',
    a: 'A note written by your calm self that appears during high-tension moments to reduce impulsive reactions.',
  },
];

export default function RelationshipIntelligenceFAQ() {
  const restartWalkthrough = () => {
    localStorage.removeItem('tension_relationship_intelligence_walkthrough_done');
  };

  return (
    <WarmMarketingBackdrop>
      <div className="mx-auto min-h-screen max-w-3xl space-y-8 px-6 py-10">
        <StockHeroStrip
          stockKey="coupleHomeRelax"
          alt="Couple relaxing together — illustrative imagery"
        />
        <Card className="border-violet-100/90 bg-white/95 p-6 shadow-lg md:p-8">
          <h1 className="text-2xl font-bold text-neutral-900 md:text-3xl">Relationship Intelligence FAQ</h1>
          <p className="mt-2 text-sm text-neutral-600 md:text-base">
            Quick explanations for every feature in the suite.
          </p>
          <Link
            to="/home#relationship-intelligence"
            className="mt-3 inline-block text-sm font-medium text-violet-700 underline-offset-2 hover:underline"
          >
            Back to Relationship Intelligence Suite
          </Link>
          <div className="mt-3">
            <Link
              to="/home#relationship-intelligence"
              onClick={restartWalkthrough}
              className="text-sm font-medium text-fuchsia-700 underline-offset-2 hover:underline"
            >
              Restart guided walkthrough
            </Link>
          </div>
        </Card>

        {FAQS.map((item) => (
          <Card key={item.q} className="border-violet-100/80 bg-white/95 p-5 shadow-md md:p-6">
            <h2 className="font-semibold text-neutral-900">{item.q}</h2>
            <p className="mt-2 text-sm leading-relaxed text-neutral-700">{item.a}</p>
          </Card>
        ))}
      </div>
    </WarmMarketingBackdrop>
  );
}
